// After a deploy, tell open tabs a new version exists. Compares the entry script named in a fresh
// index.html with the one this page loaded; never reloads on its own (unsaved work is safe).
const SCRIPT_RE = /\/assets\/index-[\w-]+\.js/;

function currentEntry(): string | null {
  for (const s of Array.from(document.querySelectorAll<HTMLScriptElement>("script[src]"))) {
    const m = s.src.match(SCRIPT_RE);
    if (m) return m[0];
  }
  return null;
}

function showBanner() {
  if (document.getElementById("update-banner")) return;
  const bar = document.createElement("div");
  bar.id = "update-banner";
  bar.setAttribute("role", "status");
  bar.style.cssText = "position:fixed;left:50%;top:10px;transform:translateX(-50%);z-index:9999;background:#0f172a;color:#fff;padding:8px 10px 8px 14px;border-radius:10px;box-shadow:0 4px 16px rgba(0,0,0,.35);display:flex;gap:10px;align-items:center;font:14px system-ui,sans-serif;max-width:calc(100vw - 20px)";
  const text = document.createElement("span");
  text.textContent = "A new version of Centerline Cloud is available.";
  const reload = document.createElement("button");
  reload.textContent = "Reload";
  reload.style.cssText = "min-height:36px;padding:0 14px;border-radius:8px;border:0;background:#2563eb;color:#fff;font-weight:600;cursor:pointer";
  reload.onclick = () => location.reload();
  const later = document.createElement("button");
  later.textContent = "Later";
  later.setAttribute("aria-label", "Dismiss");
  later.style.cssText = "min-height:36px;padding:0 10px;border-radius:8px;border:1px solid #475569;background:transparent;color:#cbd5e1;cursor:pointer";
  later.onclick = () => bar.remove();
  bar.append(text, reload, later);
  document.body.appendChild(bar);
}

export function startUpdateCheck(everyMs = 5 * 60 * 1000) {
  const mine = currentEntry();
  if (!mine) return; // dev server or unexpected markup: do nothing
  let dismissedFor: string | null = null;
  const check = async () => {
    if (document.hidden) return;
    try {
      const html = await (await fetch("/", { cache: "no-store", credentials: "same-origin" })).text();
      const latest = html.match(SCRIPT_RE)?.[0];
      if (latest && latest !== mine && latest !== dismissedFor) { showBanner(); dismissedFor = latest; }
    } catch { /* offline: try again later */ }
  };
  window.setInterval(check, everyMs);
  document.addEventListener("visibilitychange", () => { if (!document.hidden) void check(); });
}
